import { z } from 'zod';
/**
 * Marketing lead capture — the public "register interest" form on
 * clinikchat.com.au. This is CONTACT data, not health data, and never touches
 * a clinical / E2EE path. The schema is the single source of truth shared by
 * the API route and any JS client.
 *
 * The practice-management-system (PMS) field is the commercially valuable
 * signal — it tells us which integration to build next — so it is required.
 */
export const LEAD_PMS_OPTIONS = [
    'Cliniko',
    'Jane',
    'Nookal',
    'Power Diary',
    'Halaxy',
    'Other',
];
export const LEAD_TEAM_SIZE_OPTIONS = ['1-3', '4-10', '11-25', '26+'];
const emptyToUndefined = (v) => (typeof v === 'string' && v.trim() === '' ? undefined : v);
export const leadSchema = z.object({
    name: z.string().trim().min(1, 'Your name is required').max(120, 'Name is too long'),
    clinicName: z
        .string()
        .trim()
        .min(1, 'Clinic name is required')
        .max(160, 'Clinic name is too long'),
    email: z.string().trim().email('Enter a valid email address').max(254, 'Email is too long'),
    pms: z.enum(LEAD_PMS_OPTIONS, {
        errorMap: () => ({ message: 'Select your practice-management system' }),
    }),
    teamSize: z.preprocess(emptyToUndefined, z.enum(LEAD_TEAM_SIZE_OPTIONS).optional()),
    // Honeypot. Real users never see this field (hidden via CSS + aria-hidden);
    // automated spam bots fill every input. The route treats any non-empty value
    // as a bot and silently succeeds without persisting. Kept lenient here so a
    // stray browser autofill can't turn a real submission into a 400.
    website: z.preprocess(emptyToUndefined, z.string().max(200).optional()),
});
//# sourceMappingURL=lead.schema.js.map